import React from 'react'

import { formField } from 'decorators'

import Toggle from './Toggle'

export default formField(props => <Toggle {...props} />)
